import { useEffect, useState } from 'react';

/**
 * Returns `value` delayed by `delay` ms. Used to throttle search-as-you-type
 * so we don't hammer the API on every keystroke.
 */
export function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
